export default __webpack_public_path__ + "static/univers-roman-9660929b7ded6a6d4854c979c138c131.woff";